import { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import { Reveal, ScrollUnderline } from './Reveal';
import { COMPANY } from '../constants/config';

function LegalSection({ section }) {
  const ListTag = section.ordered ? 'ol' : 'ul';

  return (
    <section className="flex flex-col gap-3">
      <h2 className="text-xl font-bold text-indigo-950 sm:text-2xl">{section.heading}</h2>
      {section.paragraphs?.map((paragraph) => (
        <p key={paragraph} className="text-sm leading-relaxed text-gray-600 sm:text-base">
          {paragraph}
        </p>
      ))}
      {section.list && (
        <ListTag
          className={`flex flex-col gap-2 pl-5 text-sm leading-relaxed text-gray-600 sm:text-base ${
            section.ordered ? 'list-decimal' : 'list-disc'
          }`}
        >
          {section.list.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ListTag>
      )}
      {section.trailingParagraphs?.map((paragraph) => (
        <p key={paragraph} className="text-sm leading-relaxed text-gray-600 sm:text-base">
          {paragraph}
        </p>
      ))}
    </section>
  );
}

function LegalPageLayout({ policy }) {
  useEffect(() => {
    document.title = `${policy.title} | ${COMPANY.name}`;
  }, [policy.title]);

  return (
    <div className="flex w-full max-w-full flex-col bg-white">
      <Header />

      <main className="w-full bg-stone-50">
        <div className="mx-auto flex w-full max-w-4xl flex-col gap-10 px-4 py-12 sm:px-6 md:py-20 lg:px-8">
          <Reveal className="flex flex-col items-start gap-2" variant="slideUp" animateOnMount>
            <div className="flex items-center gap-3 text-[1.1rem] font-semibold uppercase tracking-[0.2em] text-indigo-600">
              <span className="h-[3px] w-10 bg-indigo-400" aria-hidden="true" />
              {policy.eyebrow}
            </div>
            <div className="flex flex-col">
              <h1 className="text-[1.875rem] font-extrabold leading-[1.25] tracking-tight text-indigo-950 sm:text-[2.25rem] md:text-[2.75rem]">
                {policy.title}
              </h1>
              <ScrollUnderline
                className="mt-2.5 h-[2px] w-[120px] max-w-full rounded-full bg-indigo-700"
                animateOnMount
              />
            </div>
            <p className="mt-2 text-sm font-medium text-gray-500">
              Effective Date: {policy.effectiveDate}
            </p>
          </Reveal>

          <Reveal variant="slideUp" index={1}>
            <p className="text-sm leading-relaxed text-gray-600 sm:text-base">{policy.intro}</p>
          </Reveal>

          <div className="flex flex-col gap-10">
            {policy.sections.map((section, index) => (
              <Reveal key={section.heading} variant="slideUp" index={index + 2}>
                <LegalSection section={section} />
              </Reveal>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default LegalPageLayout;
